import React from "react";

const UnorderedListIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M6.49996 4.8099H12.1666M6.49996 8.8099H12.1666M6.49996 12.8099H12.1666M4.33329 4.8099C4.33329 4.99399 4.18405 5.14323 3.99996 5.14323C3.81586 5.14323 3.66663 4.99399 3.66663 4.8099C3.66663 4.6258 3.81586 4.47656 3.99996 4.47656C4.18405 4.47656 4.33329 4.6258 4.33329 4.8099ZM4.33329 8.8099C4.33329 8.99399 4.18405 9.14323 3.99996 9.14323C3.81586 9.14323 3.66663 8.99399 3.66663 8.8099C3.66663 8.6258 3.81586 8.47656 3.99996 8.47656C4.18405 8.47656 4.33329 8.6258 4.33329 8.8099ZM4.33329 12.8099C4.33329 12.994 4.18405 13.1432 3.99996 13.1432C3.81586 13.1432 3.66663 12.994 3.66663 12.8099C3.66663 12.6258 3.81586 12.4766 3.99996 12.4766C4.18405 12.4766 4.33329 12.6258 4.33329 12.8099Z"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnorderedListIcon;
